// Video leadership refers to the ability to dictate to other peers when to play/pause,
// change volume, "jump" (seek) to another place
//
import messageBroker from '../general/messageBroker';
import commandsManager from '../general/CommandsManager';
import hooksManager from '../general/HooksManager';

let isVideoLeader = false;
let videoElement = null;

function setupVideoLeadershipMessageTypes(setVideoLeader = false, setVideoElement, setVideoLeaderCallback) {
  videoElement = setVideoElement;
  isVideoLeader = setVideoLeader;

  // Message Types
  messageBroker.registerNewMessageType('mirror--playback_status', (data) => {
    let status = data.message.status.toUpperCase();
    switch (status) {
      case 'READY':
        status += ' ✅';
        break;
      case 'PLAYING':
        status += ' ▶️';
        break;
      case 'PAUSED':
        status += ' ⏸';
        break;
      case 'ENDED':
        status += ' 🏁';
        break;
      default:
        break;
    }
    $(`#ready_${data.message.role}_${data.message.from} .status`).html(status);
    if (data.message.status.toUpperCase() === 'READY') {
      hooksManager.emit('video-leadership--user-ready', data);
    }
  });

  messageBroker.registerNewMessageType('mirror--request-video-leader', (data) => {
    // only answer to the request if its currently the video leader
    if (isVideoLeader) {
      messageBroker.sendMessage('Acknowleding new video leader', 'mirror--ack-video-leader', data.from);
      const videoLeaderButton = document.getElementById('requestVideoLeaderButton');
      videoLeaderButton.classList.remove('hidden');
      videoLeaderButton.classList.remove('disabled');
      videoLeaderButton.removeAttribute('disabled');
      isVideoLeader = false;
      if (videoElement) {
        videoElement.controls = false;
      }
      setVideoLeaderCallback(false);
    }
  });
  messageBroker.registerNewMessageType('mirror--ack-video-leader', (data) => {
    document.getElementById('requestVideoLeaderButton').classList.add('hidden');
    isVideoLeader = true;
    if (videoElement) {
      videoElement.controls = true;
    }
    setVideoLeaderCallback(true);
  });
}

function requestVideoLeader() {
  if (!isVideoLeader) {
    messageBroker.sendMessage('request video leader', 'mirror--request-video-leader');
    const videoLeaderButton = document.getElementById('requestVideoLeaderButton');
    videoLeaderButton.setAttribute('disabled', 'disabled');
    videoLeaderButton.classList.add('disabled');
  }
}

function sendEventToPeers(commandId, args) {
  // if the user is not currently the video leader then it cant send any playback events
  // this also helps avoid a feedback loop between peers.
  if (isVideoLeader === false) return;

  commandsManager.getCommandById(commandId).sendAll(args);
}

function setVideoLeadershipListenersHTML5(video) {
  video.onplay = (event) => {
    sendEventToPeers('play_video_clip');
  };

  video.onpause = (event) => {
    sendEventToPeers('pause_video_clip');
  };

  video.onseeked = (event) => {
    const args = { currentTime: video.currentTime };
    sendEventToPeers('set_time_video_clip', args);
  };

  // Other available HTML5 Events, not implemented
  video.oncanplaythrough = null;
  video.onseeking = null;
  video.onvolumechange = null;
}

function setVideoLeadershipListenersPlyr(playbackPlayer) {
  playbackPlayer.on('play', (event) => {
    sendEventToPeers('play_video_clip');
  });
  playbackPlayer.on('pause', (event) => {
    sendEventToPeers('pause_video_clip');
  });
  playbackPlayer.on('seeked', (event) => {
    const instance = event.detail.plyr;
    const args = { currentTime: instance.currentTime };
    sendEventToPeers('set_time_video_clip', args);
  });
}

export {
  setupVideoLeadershipMessageTypes, requestVideoLeader, setVideoLeadershipListenersPlyr,
  setVideoLeadershipListenersHTML5,
};
